import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Palette } from "lucide-react";
import { LEGAL_NOTES, BRAND } from "@/data/adPackage";

const swatches = [
  { name: "BiteGoFood Orange", hex: "#F97316" },
  { name: "Ember", hex: "#FB923C" },
  { name: "BiteGoFood Red", hex: "#E11D48" },
  { name: "Obsidian", hex: "#0A0A0A" },
  { name: "White", hex: "#FFFFFF" },
];

export default function BrandNotes() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
      {/* Legal / factual safety */}
      <div className="lg:col-span-7 rounded-2xl border border-white/10 bg-neutral-950 p-6">
        <div className="flex items-center gap-2 mb-5">
          <ShieldCheck className="w-5 h-5 text-emerald-400" />
          <h3 className="font-display font-black text-white text-xl">Factual & Legal Safety</h3>
        </div>
        <ul className="space-y-3">
          {LEGAL_NOTES.map((n, i) => (
            <motion.li
              key={i}
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="flex gap-3 text-sm text-neutral-300 leading-relaxed"
            >
              <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-400 shrink-0" />
              <span>{n}</span>
            </motion.li>
          ))}
        </ul>
      </div>

      {/* Brand kit */}
      <div className="lg:col-span-5 space-y-6">
        <div className="rounded-2xl border border-white/10 bg-neutral-950 p-6">
          <div className="flex items-center gap-2 mb-5">
            <Palette className="w-5 h-5 text-orange-400" />
            <h3 className="font-display font-black text-white text-xl">Brand Kit</h3>
          </div>
          <div className="flex items-center gap-4 mb-5">
            <img src={BRAND.logo} alt="BiteGoFood" className="w-16 h-16 rounded-2xl shadow-lg" />
            <div>
              <div className="font-display font-black text-white text-2xl leading-none">{BRAND.name}</div>
              <div className="text-sm text-neutral-400">{BRAND.tagline}</div>
              <a href={BRAND.websiteUrl} target="_blank" rel="noreferrer" className="text-xs text-orange-400 hover:underline">{BRAND.website}</a>
            </div>
          </div>
          <div className="grid grid-cols-5 gap-2">
            {swatches.map((s) => (
              <div key={s.name} className="text-center">
                <div className="w-full aspect-square rounded-lg border border-white/10" style={{ background: s.hex }} />
                <div className="mt-1 text-[9px] text-neutral-500 leading-tight">{s.name}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="rounded-2xl border border-white/10 bg-neutral-900/60 p-6">
          <div className="text-[10px] uppercase tracking-[0.2em] text-orange-400 font-semibold mb-2">Deliverables in this package</div>
          <ul className="text-sm text-neutral-300 space-y-1.5">
            <li>1× 16:9 master, in-browser, with VO</li>
            <li>1× 16:9 no-VO text-led version (toggle in player)</li>
            <li>Subtitle sources (VO + no-VO .srt)</li>
            <li>Storyboard, script sheet, shot list</li>
            <li>9:16 vertical-safe cut guide</li>
            <li>Generated VO audio + branded UI mockups</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
